import { render, staticRenderFns } from "./checkBoxWork.vue?vue&type=template&id=480cb52a&"
import script from "./checkBoxWork.vue?vue&type=script&lang=js&"
export * from "./checkBoxWork.vue?vue&type=script&lang=js&"
import style0 from "./checkBoxWork.vue?vue&type=style&index=0&id=480cb52a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports